















import { Component, Vue, Prop } from 'vue-property-decorator'
import CategoryResponse from '@/types/CategoryResponse'

@Component
export default class SubBrowseCategoryDisplayer extends Vue {
  @Prop() category!: CategoryResponse
  @Prop() getCategorysPlaylists!: Function
}
